module.exports = __webpack_public_path__ + "src/assets/img/lazanskaya.6e27ae69.jpg";